import { KEYS_HEADING } from '@udecode/plate';
const exitBreakPlugin = {
    options: {
        rules: [
            {
                hotkey: 'mod+enter',
            },
            {
                hotkey: 'mod+shift+enter',
                before: true,
            },
            {
                hotkey: 'enter',
                query: {
                    start: true,
                    end: true,
                    allow: KEYS_HEADING,
                },
            },
        ],
    },
};
export default exitBreakPlugin;
//# sourceMappingURL=exitBreakPlugin.js.map